import axios from "axios";
import { MAPBOX_CONFIG } from "../config/mapbox";

const baseURL = MAPBOX_CONFIG.GEOCODING_URL;

export const fetchSuggestions = (query: string) => {
  return axios({
    method: "GET",
    url: `${baseURL}/${encodeURIComponent(query)}.json`,
    params: {
      access_token: MAPBOX_CONFIG.API_KEY,
      types: MAPBOX_CONFIG.TYPES,
      autocomplete: MAPBOX_CONFIG.AUTOCOMPLETE,
      limit: MAPBOX_CONFIG.LIMIT,
      language: MAPBOX_CONFIG.LANGUAGE,
      country: MAPBOX_CONFIG.COUNTRIES,
    },
  });
};

export const getCityName = (latitude: number, longitude: number) => {
  return axios({
    method: "GET",
    url: `${baseURL}/${longitude},${latitude}.json`,
    params: {
      access_token: MAPBOX_CONFIG.API_KEY,
      types: MAPBOX_CONFIG.TYPES,
      language: MAPBOX_CONFIG.LANGUAGE,
      country: MAPBOX_CONFIG.COUNTRIES,
    },
  });
};

export const getCityCoordinates = (city: string) => {
  return axios({
    method: "GET",
    url: `${baseURL}/${encodeURIComponent(city)}.json`,
    params: {
      access_token: MAPBOX_CONFIG.API_KEY,
      types: MAPBOX_CONFIG.TYPES,
      language: MAPBOX_CONFIG.LANGUAGE,
      country: MAPBOX_CONFIG.COUNTRIES,
    },
  });
};

export const getTimezone = (latitude: number, longitude: number) => {
  return axios({
    method: "GET",
    url: `https://api.mapbox.com/v4/examples.4ze9z6tv/tilequery/${longitude},${latitude}.json?access_token=${MAPBOX_CONFIG.API_KEY}`,
  });
};
